export default __webpack_public_path__ + "static/media/Arrow-up.d44e4260.svg";